<div class="ibox ">
    <iboxtools
       [Title]=""
       [DateInit]=""
       [DateEnd]=""
       [isHistory]=false
       [IsEditing]="isEditing"
       (EditChange)="EditChange($event)"
       (SaveChange)="SaveChange($event)"
       (CancelChange)="CancelChange($event)"
       [Permiso]="permisoEdicion"
   ></iboxtools>
        <div class="ibox-content">
            <form [formGroup]="datosPersonalesForm">
                <div class="row" hidden="true">
                   <input formControlName="id" name ="id" type="text" class="form-control" />
                </div>
               
                <div class="row">
                    <div class="col-lg">
                        <p-checkbox formControlName="bloqueado" binary="true" label="Bloqueado"></p-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class="col-form-label font-bold" for="liquidarDesde">Liquida Desde</label>
                        <p-calendar appendTo="body" selectOtherMonths="true" formControlName="liquidarDesde" required dateFormat="dd/mm/yy" inputId="liquidarDesde" ngDefaultControl></p-calendar>
                        <!-- <div *ngIf="f.liquidarDesde.errors?.required && (f.liquidarDesde?.dirty || f.liquidarDesde?.touched)" class="text-danger">La Fecha Desde es Requerida</div> -->
                    </div>
                    <div class="col-lg">
                        <label class="col-form-label font-bold" for="liquidarHasta">Liquida Hasta</label>
                        <p-calendar appendTo="body" selectOtherMonths="true" formControlName="liquidarHasta" required dateFormat="dd/mm/yy" inputId="liquidarHasta" ngDefaultControl></p-calendar>
                        <!-- <div *ngIf="f.liquidarHasta.errors?.required && (f.liquidarHasta?.dirty || f.liquidarHasta?.touched)" class="text-danger">La Fecha Hasta es Requerida</div> -->
                        <mat-error  class="text-danger" *ngIf="f.liquidarHasta.errors?.fecHastaMenor && (f.liquidarHasta?.dirty || f.liquidarHasta?.touched)">
                            La Fecha no puede ser menor que la Fecha Desde
                        </mat-error>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg">
                        <label class="col-form-label font-bold" for="ultimaLiquidacion">Última Liquidación</label>
                        <p-calendar appendTo="body" selectOtherMonths="true" formControlName="ultimaLiquidacion" required dateFormat="dd/mm/yy" inputId="ultimaLiquidacion" ngDefaultControl></p-calendar>

                    </div>
                    <div class="col-lg">
                        <label class="col-form-label font-bold" for="retroactividad">Retroactividad</label>
                        <p-calendar appendTo="body" selectOtherMonths="true" formControlName="retroactividad" required dateFormat="dd/mm/yy" inputId="retroactividad" ngDefaultControl></p-calendar>

                    </div>
                </div>
           </form>
       </div>
   </div>
